import { useSelector } from "react-redux";
import Admin from "./Admin.js";
import Developer from "./Developer.js";

const Home = (props) => {
  const signdata = useSelector((state) => state.signinReducers);
  console.log("userq", signdata?.data)
  return (
    <>
    {(signdata?.data?.role == 1 || signdata?.data?.role == 7) ? (
      <Admin data={{transtion: props?.data?.transtion}} />
    ) : (
      <>
        {signdata?.data?.role != 1 ? (
          <Developer data={{transtion: props?.data?.transtion}} />
        ) : (
          ""
        )}
      </>
    )}
    </>
  );
};

export default Home;
